import $ from 'jquery';

const reportNav = (el) => {
    const $el = $(el);
    const $scroll = $el.find('.js-scroll');
    const $slider = $el.find('.js-slider');
    const $rightButton = $el.find('.js-right-button');
    const $leftButton = $el.find('.js-left-button');
    const $sliderWidth = $scroll.width();

    $rightButton.on('click', function () {
        $slider.animate({scrollLeft: '+=120'});
    });

    $leftButton.on('click', function () {
        $('.js-slider').animate({scrollLeft: '-=120'});
    });

    $slider.on('scroll', function (e) {
        let horizontalScroll = e.currentTarget.scrollLeft;
        let horizontalWidth = e.currentTarget.scrollWidth - e.currentTarget.clientWidth - 1;

        if(horizontalScroll > 1) {
            $el.addClass('js-scroll-right');
        } else {
            $el.removeClass('js-scroll-right');
        }

        if(horizontalScroll >= horizontalWidth) {
            $el.addClass('js-scroll-left');
        } else {
            $el.removeClass('js-scroll-left');
        }
    });

    if($sliderWidth >= 1310) {
        $el.addClass('js-has-scroll');
    }

    $(document).on('scroll', function () {
        
        // handle current section highlighting in mobile navigation
        const $currentNavItem = $('.js-report-nav-item-active').text();
        if($currentNavItem) {
            $('.report-nav__parent').text($currentNavItem);
        }

        const $offset = 800;
        const $newsletter = $('.js-newsletter').offset().top - $offset;

        // remove navigation before newsletter module
        const $currentPosition = $(document).scrollTop();
        if($currentPosition > $newsletter) {
            $('.report-nav').addClass('report-nav--slide-up');
        } else {
            $('.report-nav').removeClass('report-nav--slide-up');
        }
    });

    // handle automatic current section highlighting 
    const handleTocIntersection = (entries) =>
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const sectionId = $(entry.target).data('section-id');
                
                // remove active class from all items
                $('.js-report-nav-item').removeClass('js-report-nav-item-active');

                // add active class to current item
                $(`.js-report-nav-item[data-section-id=${sectionId}]`)
                    .addClass('js-report-nav-item-active');
            }
        }); 
    
    // create intersection observer for each report section
    const tocIntersectionObserver = new IntersectionObserver(handleTocIntersection);
    $('.js-report-section-heading').map((i, section) => 
        tocIntersectionObserver.observe(section)
    );

};

export default reportNav;
